import axios from 'axios';
import { publicMapTokenService, TokenData } from './publicMapToken';

// Função para determinar a baseURL com base no ambiente
const getBaseUrl = () => {
  // Se estamos em ambiente de produção (domínio público)
  if (window.location.hostname.includes('digitalint.com.br')) {
    // Usar o subdomínio apimapasrio.digitalint.com.br
    return 'https://apimapasrio.digitalint.com.br';
    //return 'https://172.16.9.40:1053';
  }
  // Em ambiente de desenvolvimento local
  //return 'https://172.16.9.40:1053';
  return 'https://apimapasrio.digitalint.com.br';
};

const api = axios.create({
  baseURL: getBaseUrl(),
  // Ignorar erros de certificado para desenvolvimento local
  httpsAgent: new (require('https').Agent)({ rejectUnauthorized: false })
});

// Interceptor para simular endpoints do backend que ainda não existem
api.interceptors.request.use(
  async (config) => {
    // Simular o endpoint /public/map/:token (formato antigo)
    if (config.url?.match(/\/public\/map\/([^/]+)$/) && !config.url?.includes('/direct/')) {
      console.log('Interceptando requisição para mapa público com token:', config.url);
      
      const token = config.url.split('/').pop();
      console.log('Token extraído da URL:', token);
      
      if (!token) {
        console.error('Token não fornecido na URL');
        throw new axios.Cancel('Token não fornecido');
      }
      
      // Verificar se temos tokens salvos no localStorage
      const savedTokens = JSON.parse(localStorage.getItem('publicMapTokens') || '[]');
      console.log('Tokens salvos no localStorage:', savedTokens);
      
      // Decodificar o token para extrair os dados
      try {
        const tokenData = JSON.parse(atob(token));
        console.log('Dados do token decodificado:', tokenData);
        
        if (!tokenData || !tokenData.empresaMae || !tokenData.obra) {
          console.error('Token inválido ou mal formado');
          throw new axios.Cancel('Token inválido');
        }
        
        const { empresaMae, obra } = tokenData;
        
        // Usar o mock para simular a resposta do backend temporariamente
        config.adapter = () => {
          return new Promise((resolve) => {
            setTimeout(async () => {
              try {
                console.log('Buscando dados para:', { empresaMae, obra });
                
                // Tentar buscar dados reais do empreendimento
                const empreendimentosResponse = await axios.get(
                  `${config.baseURL}/Mapas/Empreendimentos?empresaMae=${empresaMae}`,
                  { headers: config.headers }
                );
                
                const empreendimento = empreendimentosResponse.data?.empreendimentos?.find(
                  (e: any) => e.sigla === obra
                );
                
                if (empreendimento) {
                  // Buscar os dados do mapa para este empreendimento
                  const mapResponse = await axios.get(
                    `${config.baseURL}/Mapas?empresaMae=${empresaMae}&obra=${obra}`,
                    { headers: config.headers }
                  );
                  
                  resolve({
                    data: {
                      success: true,
                      mapData: {
                        ...mapResponse.data,
                        nome: empreendimento.descricao || obra,
                        empresa: empreendimento.empresa || '',
                        empresaMae
                      },
                      tokenData
                    },
                    status: 200,
                    statusText: 'OK',
                    headers: {},
                    config
                  });
                } else {
                  resolve({
                    data: { success: false, message: 'Empreendimento não encontrado' },
                    status: 404,
                    statusText: 'Not Found',
                    headers: {},
                    config
                  });
                }
              } catch (error) {
                console.error('Erro ao processar requisição:', error);
                resolve({
                  data: { success: false, message: 'Erro ao processar requisição' },
                  status: 500,
                  statusText: 'Internal Server Error',
                  headers: {},
                  config
                });
              }
            }, 500);
          });
        };
        
        return config;
      } catch (error) {
        console.error('Erro ao decodificar token:', error);
        throw new axios.Cancel('Token inválido');
      }
    }
    
    // Simular o endpoint /public/map/direct/:empresaMae/:obra (novo formato)
    if (config.url?.match(/\/public\/map\/direct\/([^/]+)\/([^/]+)$/)) {
      console.log('Interceptando requisição para mapa público direto:', config.url);
      
      const urlParts = config.url.split('/');
      const obra = urlParts.pop() || '';
      const empresaMae = urlParts.pop() || '';
      
      console.log('Parâmetros extraídos da URL:', { empresaMae, obra });
      
      if (!empresaMae || !obra) {
        console.error('Parâmetros incompletos na URL');
        throw new axios.Cancel('Parâmetros incompletos');
      }
      
      // Usar o mock para simular a resposta do backend temporariamente
      // Em uma implementação real, isso viria do backend
      config.adapter = () => {
        return new Promise((resolve) => {
          // Aqui devemos buscar os dados reais do mapa baseados nos parâmetros
          // Simulando busca para o empreendimento específico
          setTimeout(async () => {
            try {              
              console.log('Buscando dados para:', { empresaMae, obra });
              
              // Tentar buscar dados reais do empreendimento
              const empreendimentosResponse = await axios.get(
                `${config.baseURL}/Mapas/Empreendimentos?empresaMae=${empresaMae}`,
                { headers: config.headers }
              );
              
              console.log('Resposta de empreendimentos:', empreendimentosResponse.data);
              
              const empreendimento = empreendimentosResponse.data?.empreendimentos?.find(
                (e: any) => e.sigla === obra
              );
              
              console.log('Empreendimento encontrado:', empreendimento);
              
              if (empreendimento) {
                // Buscar os dados do mapa para este empreendimento
                const mapResponse = await axios.get(
                  `${config.baseURL}/Mapas?empresaMae=${empresaMae}&obra=${obra}`,
                  { headers: config.headers }
                );
                
                console.log('Dados do mapa obtidos:', mapResponse.data);
                
                resolve({
                  data: {
                    success: true,
                    mapData: {
                      ...mapResponse.data,
                      nome: empreendimento.descricao || obra,
                      empresa: empreendimento.empresa || '',
                      empresaMae
                    }
                  },
                  status: 200,
                  statusText: 'OK',
                  headers: {},
                  config
                });
              } else {
                // Empreendimento não encontrado
                resolve({
                  data: {
                    success: false,
                    error: 'Empreendimento não encontrado'
                  },
                  status: 404,
                  statusText: 'Not Found',
                  headers: {},
                  config
                });
              }
            } catch (error) {
              // Erro ao buscar dados, retornar erro simulado
              resolve({
                data: {
                  success: false,
                  error: 'Erro ao buscar dados do mapa'
                },
                status: 500,
                statusText: 'Server Error',
                headers: {},
                config
              });
            }
          }, 800); // Delay para simular latência da rede
        });
      };
    }
    
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
